import { TBaseCalculatorData, TCalculatorError, TItem, TWidget } from '@libs/types';
import React from 'react';
import { CurrencyDropdownEnum, InputEnum, THandleButtonClick, THandleUpdateValue, TServerCalculationFunc } from '../utils/types';
import CalculatorError from './CalculatorError';
import { CurrencyDropdownV1 } from './CurrencyDropdownV1';

type TCalculatorInputSubRowProps = {
    widget: TWidget<TBaseCalculatorData>;
    dropdownName: CurrencyDropdownEnum;
    inputName: InputEnum;
    value: string;
    newInputValue?: string;
    index: number;
    flagName?: string;
    isFrom?: boolean;
    isTopUp?: boolean;
    isSingleCurrency: boolean;
    items: TItem[];
    error?: TCalculatorError;
    dropDownHeader: string;
    searchPlaceholder?: string;
    noFoundText?: string;
    currencyText?: string;
    buttonGotItLabel?: string;
    buttonIncreaseLimitLabel?: string;
    buttonChangeAmountLabel?: string;
    buttonChangeDeliveryOptionLabel?: string;
    buttonChangeTransferOptionLabel?: string;
    onServerCalculation: TServerCalculationFunc;
    handleUpdateValue: THandleUpdateValue;
    handleButtonClick?: THandleButtonClick;
    parentStyleNames?: string[];
};
const CalculatorInputSubRowV1 = ({
    widget,
    dropdownName,
    inputName,
    value,
    newInputValue,
    index,
    flagName,
    isFrom,
    onServerCalculation,
    handleUpdateValue,
    handleButtonClick,
    items,
    error,
    dropDownHeader,
    searchPlaceholder,
    noFoundText,
    currencyText,
    isTopUp,
    isSingleCurrency,
    parentStyleNames,
    buttonGotItLabel = '',
    buttonIncreaseLimitLabel = '',
    buttonChangeAmountLabel = '',
    buttonChangeDeliveryOptionLabel = '',
    buttonChangeTransferOptionLabel = '',
}: TCalculatorInputSubRowProps) => {
    if (error && Object.keys(error).length > 0) {
        return (
            <CalculatorError
                widget={widget}
                error={error}
                name={inputName}
                newInputValue={newInputValue}
                handleUpdateValue={handleUpdateValue}
                handleButtonClick={handleButtonClick}
                buttonGotItLabel={buttonGotItLabel}
                buttonIncreaseLimitLabel={buttonIncreaseLimitLabel}
                buttonChangeAmountLabel={buttonChangeAmountLabel}
                buttonChangeDeliveryOptionLabel={buttonChangeDeliveryOptionLabel}
                buttonChangeTransferOptionLabel={buttonChangeTransferOptionLabel}
                parentStyleNames={parentStyleNames}
            />
        );
    }
    return (
        <CurrencyDropdownV1
            widget={widget}
            isFrom={isFrom}
            isTopUp={isTopUp}
            items={items}
            index={index}
            searchPlaceholder={searchPlaceholder}
            header={dropDownHeader}
            noFoundText={noFoundText}
            currencyText={currencyText}
            buttonChangeTransferOptionLabel={buttonChangeTransferOptionLabel}
            name={dropdownName}
            value={value}
            flagName={flagName}
            onServerCalculation={onServerCalculation}
            isSingleCurrency={isSingleCurrency}
            parentStyleNames={parentStyleNames}
        />
    );
};
export { CalculatorInputSubRowV1 };
